"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    transition: prop_types_1.default.string,
    transitionDelay: prop_types_1.default.string,
    transitionDuration: prop_types_1.default.string,
    transitionProperty: prop_types_1.default.string,
    transitionTimingFunction: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const transition = {
    className: 'tstn',
    cssName: 'transition',
    jsName: 'transition',
    complexValue: true
};
const transitionDelay = {
    className: 'tstn-dly',
    cssName: 'transition-delay',
    jsName: 'transitionDelay',
    complexValue: true
};
const transitionDuration = {
    className: 'tstn-drn',
    cssName: 'transition-duration',
    jsName: 'transitionDuration',
    complexValue: true
};
const transitionProperty = {
    className: 'tstn-pty',
    cssName: 'transition-property',
    jsName: 'transitionProperty',
    complexValue: true
};
const transitionTimingFunction = {
    className: 'tstn-tf',
    cssName: 'transition-timing-function',
    jsName: 'transitionTimingFunction',
    complexValue: true
};
exports.propEnhancers = {
    transition: (value) => get_css_1.default(transition, value),
    transitionDelay: (value) => get_css_1.default(transitionDelay, value),
    transitionDuration: (value) => get_css_1.default(transitionDuration, value),
    transitionProperty: (value) => get_css_1.default(transitionProperty, value),
    transitionTimingFunction: (value) => get_css_1.default(transitionTimingFunction, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNpdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvdHJhbnNpdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDREQUFrQztBQUNsQyx5REFBK0I7QUFHbEIsUUFBQSxTQUFTLEdBQXFCO0lBQ3pDLFVBQVUsRUFBRSxvQkFBUyxDQUFDLE1BQU07SUFDNUIsZUFBZSxFQUFFLG9CQUFTLENBQUMsTUFBTTtJQUNqQyxrQkFBa0IsRUFBRSxvQkFBUyxDQUFDLE1BQU07SUFDcEMsa0JBQWtCLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQ3BDLHdCQUF3QixFQUFFLG9CQUFTLENBQUMsTUFBTTtDQUMzQyxDQUFBO0FBRVksUUFBQSxXQUFXLEdBQWdCLEVBQUUsQ0FBQTtBQUU3QixRQUFBLGNBQWMsR0FBbUIsRUFBRSxDQUFBO0FBRWhELE1BQU0sVUFBVSxHQUFHO0lBQ2pCLFNBQVMsRUFBRSxNQUFNO0lBQ2pCLE9BQU8sRUFBRSxZQUFZO0lBQ3JCLE1BQU0sRUFBRSxZQUFZO0lBQ3BCLFlBQVksRUFBRSxJQUFJO0NBQ25CLENBQUE7QUFDRCxNQUFNLGVBQWUsR0FBRztJQUN0QixTQUFTLEVBQUUsVUFBVTtJQUNyQixPQUFPLEVBQUUsa0JBQWtCO0lBQzNCLE1BQU0sRUFBRSxpQkFBaUI7SUFDekIsWUFBWSxFQUFFLElBQUk7Q0FDbkIsQ0FBQTtBQUNELE1BQU0sa0JBQWtCLEdBQUc7SUFDekIsU0FBUyxFQUFFLFVBQVU7SUFDckIsT0FBTyxFQUFFLHFCQUFxQjtJQUM5QixNQUFNLEVBQUUsb0JBQW9CO0lBQzVCLFlBQVksRUFBRSxJQUFJO0NBQ25CLENBQUE7QUFDRCxNQUFNLGtCQUFrQixHQUFHO0lBQ3pCLFNBQVMsRUFBRSxVQUFVO0lBQ3JCLE9BQU8sRUFBRSxxQkFBcUI7SUFDOUIsTUFBTSxFQUFFLG9CQUFvQjtJQUM1QixZQUFZLEVBQUUsSUFBSTtDQUNuQixDQUFBO0FBQ0QsTUFBTSx3QkFBd0IsR0FBRztJQUMvQixTQUFTLEVBQUUsU0FBUztJQUNwQixPQUFPLEVBQUUsNEJBQTRCO0lBQ3JDLE1BQU0sRUFBRSwwQkFBMEI7SUFDbEMsWUFBWSxFQUFFLElBQUk7Q0FDbkIsQ0FBQTtBQUVZLFFBQUEsYUFBYSxHQUFrQjtJQUMxQyxVQUFVLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLFVBQVUsRUFBRSxLQUFLLENBQUM7SUFDdkUsZUFBZSxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxlQUFlLEVBQUUsS0FBSyxDQUFDO0lBQ2pGLGtCQUFrQixFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxrQkFBa0IsRUFBRSxLQUFLLENBQUM7SUFDdkYsa0JBQWtCLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLGtCQUFrQixFQUFFLEtBQUssQ0FBQztJQUN2Rix3QkFBd0IsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsd0JBQXdCLEVBQUUsS0FBSyxDQUFDO0NBQ3BHLENBQUEifQ==